const SubTitle = ({ title }) => (<p className='text-left font-bold'>{title}</p>)

export default SubTitle